import { render, staticRenderFns } from "./WeatherAlert.vue?vue&type=template&id=2a38d614&scoped=true"
import script from "./WeatherAlert.vue?vue&type=script&lang=js"
export * from "./WeatherAlert.vue?vue&type=script&lang=js"
import style0 from "./WeatherAlert.vue?vue&type=style&index=0&id=2a38d614&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a38d614",
  null
  
)

export default component.exports